import queryString from 'query-string';

export const generateSurvey = (surveyId, options) => {
	if (typeof options === 'undefined') {
		return `https://www.surveycake.com/s/${surveyId}`;
	}
	return `https://www.surveycake.com/s/${surveyId}?${queryString.stringify(options)}`;
};



// WEBPACK FOOTER //
// ./src/util/survey.js